function Disclaimer() {
  return (
    <div className="disclaimer-box">
      <div className="website-info info-box">
        <p>
          Find more inspiration about animal sounds around the world on
          <a href="https://www.boredpanda.com/animal-sounds-different-languages-james-chapman/">
            How do animals sound in different languages?
          </a>
        </p>
      </div>
      <div className="website-info info-box">
        <p>
          I found all animal audio sounds at
          <a href="https://www.freesoundslibrary.com">
            www.freesoundslibrary.com
          </a>
        </p>
      </div>
      <div className="flat-icon-info info-box">
        <div>
          <p>
            Icons made by{" "}
            <a
              href="https://www.flaticon.com/free-icons/greek"
              title="greek icons"
            >
              IYAHICON
            </a>
            ,{" "}
            <a
              href="https://www.flaticon.com/free-icons/world"
              title="world icons"
            >
              turkkub
            </a>
            ,{" "}
            <a
              href="https://www.flaticon.com/free-icons/india"
              title="india icons"
            >
              Dighital
            </a>
            ,{" "}
            <a
              href="https://www.flaticon.com/free-icons/estonian"
              title="estonian icons"
            >
              GeekClick
            </a>
            ,{" "}
            <a href="https://www.freepik.com" title="Freepik">
              Freepik
            </a>
            ,{" "}
            <a
              href="https://www.flaticon.com/authors/roundicons"
              title="Roundicons"
            >
              Roundicons
            </a>
            ,{" "}
            <a
              href="https://www.flaticon.com/authors/iconmarketpk"
              title="IconMarketPK"
            >
              IconMarketPK
            </a>
            ,{" "}
            <a
              href="https://www.flaticon.com/authors/geekclick"
              title="GeekClick"
            >
              GeekClick
            </a>{" "}
            and{" "}
            <a
              href="https://www.flaticon.com/authors/iconsbox"
              title="IconsBox"
            >
              IconsBox
            </a>{" "}
            from{" "}
            <a href="https://www.flaticon.com/" title="Flaticon">
              www.flaticon.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Disclaimer;
